
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import { Style, Icon } from 'ol/style';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
export default {
  methods: {
    addSearchAddressPoint(coords) {
      const addressPoint = new Feature();
      const addressPointGeometry = new Point(coords);
      addressPoint.setGeometry(addressPointGeometry);
      this.getLayerByName('searchAddressLayer')
        .getSource()
        .addFeature(addressPoint);
    },
    clearSearchAddress() {
      const searchAddressLayer = this.getLayerByName('searchAddressLayer');
      if (searchAddressLayer) {
        searchAddressLayer.getSource().clear();
      }
    },
    initSearchAddressLayer() {
      this.map.addLayer(
        new VectorLayer({
          name: 'searchAddressLayer',
          source: new VectorSource(),
          style: new Style({
            image: new Icon({
              anchor: [15, 38],
              anchorXUnits: 'pixels',
              anchorYUnits: 'pixels',
              src: require('@/assets/marker_search_address.svg')
            }),
          })
        })
      );
    },
    searchAddress(coords) {
      if (!this.getLayerByName('searchAddressLayer')) {
        this.initSearchAddressLayer();
      } else {
        this.clearSearchAddress();
      }
      this.addSearchAddressPoint(coords);

      this.map.getView().setCenter(coords);
      this.map.getView().setZoom(10);
    },
  }
}